import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Button, Link, Section, Icon } from '@lanl-web/lanl-components';

import './SearchCatalog.scss';

const handleSearch = (e) => {
  if (e.key === 'Enter' || e.type === 'click') {
    const value = document.getElementById('search-input').value;
    window.location.replace(
      `https://searcher-green.lanl.gov/webapps/LANL_External#/search?q=${encodeURIComponent(
        value,
      )}`,
    );
  }
};

export const SearchCatalog = ({ className }) => {
  const classes = classNames('search-catalog', className);

  return (
    <Section className={classes} backgroundColor='white'>
      <h1>Search the catalog</h1>
      <div className='search-container'>
        <div className='input-group search-group'>
          <input
            type='text'
            placeholder=''
            id='search-input'
            className='search-input'
            onKeyDown={handleSearch}
          />
          <div className='input-group-prepend my-auto'>
            <Icon icon='search' className='search-icon' />
          </div>
        </div>
        <Button onClick={(e) => handleSearch(e)} arrow={false}>
          Search
        </Button>
      </div>
      <Link href='https://www.lanl.gov/library/onsite.php' className='mt-auto'>
        On site? Go here instead
      </Link>
    </Section>
  );
};

SearchCatalog.defaultProps = {};

SearchCatalog.propTypes = {
  className: PropTypes.string,
};

export default SearchCatalog;
